import React from "react";
import { Icon } from "@chakra-ui/icons";

import { ReactComponent as ArrowRightDownLineIcon } from "../../assets/arrow-right-down-line.svg";

export const ArrowRightDownLine = (props) => {
  return <Icon as={ArrowRightDownLineIcon} {...props} />;
};
